import { Dropdown } from "antd";
import classnames from "classnames";
import { findKey, isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdMenu, MdMenuOpen } from "react-icons/md";
import logo from "shared/assets/images/logo.svg";
import Avatar from "shared/components/Avatar";
import Profile from "shared/components/Profile";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { USER_TYPES } from "utils/constants";
import Menu from "../Menu";
import { get } from "lodash";

const COLLAPSED_KEY = "sidebar.collapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === "true";
  } catch (_) {
    return false;
  }
};

const Sidebar = ({ menu, actions }) => {
  const { user } = useContext(StoreContext);
  const { t } = useTranslation(NAME_SPACES.HOME);
  const USER_TYPES_TRANSLATION = t("USER_TYPES", { returnObjects: true });
  const [isOpen, setIsopen] = useState(false);
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const closeSidebar = () => setIsopen(false);
  const openSidebar = () => {
    setCollapsed(false);
    setIsopen(true);
  };
  const hideSidebar = () => {
    setCollapsed(true);
    setIsopen(false);
  };

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch (_) {}
  }, [collapsed]);

  if (isEmpty(menu)) return null;
  const icon = !get(user, "organization.broker.isInternal")
    ? get(user, "organization.icon") || logo
    : logo;

  return (
    <>
      <div
        className={classnames("sidebar__area", {
          show: isOpen,
          "sidebar__area--collapsed": collapsed,
        })}
      >
        <button
          type="button"
          className="sidebar__collapse"
          aria-label={collapsed ? t("SIDEBAR.EXPAND") : t("SIDEBAR.COLLAPSE")}
          title={collapsed ? t("SIDEBAR.EXPAND") : t("SIDEBAR.COLLAPSE")}
          aria-expanded={!collapsed}
          onClick={hideSidebar}
        >
          {collapsed ? <MdMenu size={22} /> : <MdMenuOpen size={22} />}
        </button>
        <div className="sidebar__area--head">
          <img src={icon} alt="" />
        </div>
        <div className="sidebar__area--body">
          <div className="sidebar__area--menu">
            <Menu topics={menu} />
          </div>
        </div>
        <div className="sidebar__area--bottom">
          <Dropdown
            menu={{ items: actions }}
            trigger={["click"]}
            placement="topLeft"
          >
            <Profile
              avatar={
                <Avatar
                  mode={"text"}
                  value={`${user?.firstname?.substring(
                    0,
                    1,
                  )}${user?.lastname?.substring(0, 1)}`}
                />
              }
              title={`${user.firstname} ${user.lastname}`}
              type={
                USER_TYPES_TRANSLATION[
                  findKey(USER_TYPES, ({ type }) => type === user.meta.type)
                ]
              }
            />
          </Dropdown>
        </div>
      </div>
      <button
        type="button"
        className="float__menu"
        aria-label={t("SIDEBAR.EXPAND")}
        title={t("SIDEBAR.EXPAND")}
        aria-expanded={isOpen}
        onClick={openSidebar}
      >
        <MdMenu size={22} />
      </button>
      <div
        className={classnames("sidebar--overlay", { active: isOpen })}
        onClick={closeSidebar}
      ></div>
    </>
  );
};

export default Sidebar;
